import { createSlice } from "@reduxjs/toolkit";

const cuentacobrarState = {
  datacuentacobrar: []
}

export const cuentaporcobrarSlice = createSlice({
  name: "cuentaporcobrar",
  initialState: cuentacobrarState,
  reducers: {
    StoreCuentaCobrarData: (state, actions) => {
      state.datacuentacobrar = actions.payload;
    },
    ResetCuentaCobrarData: () => cuentacobrarState,
  }
});

export const { StoreCuentaCobrarData, ResetCuentaCobrarData } = cuentaporcobrarSlice.actions;

export default cuentaporcobrarSlice.reducer;
